/**
 * PURPOSE: Pantalla de ingreso con nombre + código para árbitros.
 * ROUTE: src/pages/VolleyballViewer/components/ViewerAccessGate.jsx
 */

import { useState } from "react";
import { FaLock, FaVolleyball } from "react-icons/fa6";

export default function ViewerAccessGate({ status, loading, error, onSubmit }) {
  const [viewerName, setViewerName] = useState("");
  const [viewerRole, setViewerRole] = useState("REFEREE_1");
  const [code, setCode] = useState("");
  const [remember, setRemember] = useState(false);
  const [localError, setLocalError] = useState(null);

  const disabled = loading || !status?.enabled;
  const visibleError = localError || error;

  async function handleSubmit(e) {
    e.preventDefault();
    setLocalError(null);

    try {
      await onSubmit({ viewerName, viewerRole, code, remember });
    } catch (err) {
      // Blindaje extra: aunque el hook ya no relanza, ningún error futuro debe tumbar la UI.
      setLocalError(err?.message || "No se pudo ingresar al módulo.");
    }
  }

  return (
    <main className="min-h-screen bg-gradient-to-br from-indigo-950 via-slate-950 to-slate-900 px-4 py-8 text-white">
      <div className="mx-auto flex min-h-[calc(100vh-4rem)] max-w-md flex-col justify-center">
        <div className="rounded-[2rem] border border-white/10 bg-white/10 p-5 shadow-2xl backdrop-blur">
          <div className="mx-auto grid h-16 w-16 place-items-center rounded-3xl bg-white text-indigo-700 shadow-lg">
            <FaVolleyball className="h-8 w-8" />
          </div>
          <div className="mt-4 text-center">
            <div className="text-xs font-black uppercase tracking-[0.24em] text-indigo-200">HAYLLIS</div>
            <h1 className="mt-1 text-2xl font-black">Visualización Arbitral</h1>
            <p className="mt-2 text-sm text-white/70">Ingresa el código brindado por mesa para ver la cancha en vivo.</p>
          </div>

          {!status?.enabled ? (
            <div className="mt-4 rounded-2xl border border-amber-300/30 bg-amber-400/10 px-4 py-3 text-sm font-bold text-amber-100">
              El módulo todavía no está activo para este partido.
            </div>
          ) : null}

          {visibleError ? (
            <div className="mt-4 rounded-2xl border border-rose-300/30 bg-rose-400/10 px-4 py-3 text-sm font-bold text-rose-100">
              {visibleError}
            </div>
          ) : null}

          <form onSubmit={handleSubmit} className="mt-5 space-y-3">
            <label className="block">
              <span className="text-xs font-black uppercase tracking-[0.14em] text-white/60">Nombre</span>
              <input
                value={viewerName}
                onChange={(e) => setViewerName(e.target.value)}
                className="mt-1 w-full rounded-2xl border border-white/10 bg-white px-4 py-3 text-sm font-bold text-slate-950 outline-none"
                placeholder="Ej. Árbitro principal"
                maxLength={120}
              />
            </label>

            <label className="block">
              <span className="text-xs font-black uppercase tracking-[0.14em] text-white/60">Rol</span>
              <select
                value={viewerRole}
                onChange={(e) => setViewerRole(e.target.value)}
                className="mt-1 w-full rounded-2xl border border-white/10 bg-white px-4 py-3 text-sm font-bold text-slate-950 outline-none"
              >
                <option value="REFEREE_1">Árbitro 1</option>
                <option value="REFEREE_2">Árbitro 2</option>
                <option value="OTHER">Otro visualizador</option>
              </select>
            </label>

            <label className="block">
              <span className="text-xs font-black uppercase tracking-[0.14em] text-white/60">Código</span>
              <div className="mt-1 flex items-center rounded-2xl border border-white/10 bg-white px-4 py-3 text-slate-950">
                <FaLock className="mr-2 h-3.5 w-3.5 text-slate-400" />
                <input
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  className="min-w-0 flex-1 bg-transparent text-sm font-black outline-none"
                  placeholder="Código de acceso"
                />
              </div>
            </label>

            <label className="flex items-center gap-2 text-xs font-semibold text-white/70">
              <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
              Recordar en este dispositivo
            </label>

            <button
              type="submit"
              disabled={disabled}
              className="w-full rounded-2xl bg-emerald-500 px-4 py-3 text-sm font-black uppercase tracking-[0.12em] text-white shadow-lg shadow-emerald-950/30 transition hover:bg-emerald-400 disabled:cursor-not-allowed disabled:opacity-40"
            >
              {loading ? "Validando..." : "Entrar"}
            </button>
          </form>
        </div>
      </div>
    </main>
  );
}
